import { render, staticRenderFns } from "./EditWidget.vue?vue&type=template&id=616e397d&"
import script from "./EditWidget.vue?vue&type=script&lang=ts&"
export * from "./EditWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports